export const TELEMEDICINE_CATEGORY_IDS = {
  TREATMENT: {
    COLD: '1',
    HAIRLOSS: '9',
    ACNE: '11',
    ARTIFICIAL_TEARS: '558',
    DIET: '12',
  },
  DEPARTMENT: {
    PEDIATRICS: '2',
  },
} as const;

// 하위 호환성을 위한 별칭
export const TREATMENT_CATEGORIES_IDS = {
  Hairloss: TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS,
  Acne: TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE,
  Diet: TELEMEDICINE_CATEGORY_IDS.TREATMENT.DIET,
  Cold: TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD,
  ArtificialTears: TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS,
} as const;

export const DEPARTMENT_CATEGORIES_IDS = {
  Pediatrics: TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS,
} as const;
